import React from 'react';
import { useAuth } from '../middleware/AuthContext';
import Button from '../components/Button'; // Assuming Button component is already defined

const ForbiddenPage: React.FC = () => {
const { logout } = useAuth(); // Use auth context
    
  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-5xl font-bold text-red-500">403 Forbidden</h1>
        <p className="text-lg">You do not have permission to access this page.</p>
      <div className="space-y-3">
        <Button variant='primary' onClick={logout}>
          Logout
        </Button>
          </div>
      </div>
    </div>
  );
};

export default ForbiddenPage;
